import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { FilterIcon, Loader2 } from "lucide-react";
import { DropdownMenuSeparator } from "@radix-ui/react-dropdown-menu";
import { useEffect, useState } from "react";
import { Label } from "./ui/label";
import CustomLabelText from "./CustomLabelText";
import VendorSelect from "./VendorSelect";
import { formatSubcontractorName, getModuleNamingBySlug } from "../lib/Misc";
import ContactSelect from "./ContactSelect";
import AssetSelect from "./AssetSelect";
import SubAssetSelect from "./SubAssetSelect";
import TrustSelect from "./TrustSelect";
import { useOrganization } from "../lib/context/OrganisationContext";
import ContractSelect from "./ContractSelect";
import { TrustSelectMulti } from "./TrustSelectMulti";
import { VendorSelectMulti } from "./VendorSelectMulti";
import { ContactSelectMulti } from "./ContactSelectMulti";
import { SubAssetSelectMulti } from "./SubAssetSelectMulti";
import SearchSelect from "./SearchSelect";
import BeneficarySelect from "./BeneficarySelect";
import { BeneficarySelectMulti } from "./BeneficariesSelectMulti";
import { UserSelectMulti } from "./UserSelectMulti";
import UserSelect from "./UserSelect";

// 1. Local state to track filter values
let _trustId,
  _vendorId,
  _contactId,
  _assetId,
  _sub_assetId,
  _contractId,
  _beneficaryId,
  _userId;

// 2. Exported function to get current state
export function getSelectedFilters() {
  return {
    trustId: _trustId,
    vendorId: _vendorId,
    contactId: _contactId,
    assetId: _assetId,
    sub_assetId: _sub_assetId,
    contractId: _contractId,
    beneficaryId: _beneficaryId,
    userId: _userId,
  };
}

const getCount = (val) => {
  if (!val) return 0;
  if (Array.isArray(val)) return val.length > 0 ? 1 : 0;
  return 1; // single selected value
};

export default function CommonFilters({
  orgId = "",
  trust = false,
  trustId = "",
  multiTrust = false,
  setTrustListData,
  setTrustId,
  contact = false,
  contactId = "",
  setContactId,
  multiContact = false,
  initalContact,
  vendor = false,
  vendorId = "",
  setVendorId,
  multiVendor = false,
  initialVendor,
  asset = false,
  assetId = "",
  setAssetId,
  initialAsset,
  subAsset = false,
  subAssetId = "",
  setSubAssetId,
  multiSubAsset = false,
  initialSubAsset,
  contract = false,
  contractId = "",
  setContractId,
  aml_ctf_contact = false,
  amlCtfContactId = "",
  setAmlCtfContactId,
  reversed = false,
  reversedId = "",
  setReversedId,
  refund = false,
  refundId = "",
  setRefundId,
  disposed = false,
  disposedId = "",
  setDisposedId,
  reportFilterList = [],
  reportFilter = false,
  reportFilterValue = "",
  setReportFilterValue,
  amlDashboardFilter = false,
  amlDashboardValue = "",
  setAmlDashboardValue,
  beneficary = false,
  beneficaryId = "",
  setBeneficaryId,
  multiBeneficary = false,

  user = false,
  userId = "",
  setUserId,
  multiUser = false,
}) {
  const { organizationData } = useOrganization();
  const [trustLoading, setTrustLoading] = useState(false);
  const [trustListing, setTrustListing] = useState([]);
  const [trustList, setTrustList] = useState([]);

  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorListing, setVendorListing] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  const [assetLoading, setAssetLoading] = useState(false);
  const [assetListing, setAssetListing] = useState([]);
  const [assetList, setAssetList] = useState([]);

  const [subAssetLoading, setSubAssetLoading] = useState(false);
  const [subAssetListing, setSubAssetListing] = useState([]);
  const [subAssetList, setSubAssetList] = useState([]);

  const [contactLoading, setContactLoading] = useState(false);
  const [contactListing, setContactListing] = useState([]);
  const [contactList, setContactList] = useState([]);

  const [contractLoading, setContractLoading] = useState(false);
  const [contractListing, setContractListing] = useState([]);
  const [contractList, setContractList] = useState([]);
  const [trustIdsSetOnce, setTrustIdsSetOnce] = useState(false);

  const [beneficaryLoading, setBeneficaryLoading] = useState(false);
  const [beneficaryListing, setBeneficaryListing] = useState([]);
  const [beneficaryList, setBeneficaryList] = useState([]);

  const [userLoading, setUserLoading] = useState(false);
  const [userListing, setUserListing] = useState([]);
  const [userList, setUserList] = useState([]);

  const commonList = [
    {
      label: "Yes",
      value: "1",
    },
    {
      label: "No",
      value: "0",
    },
  ];

  const amlDashboardList = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Contact",
      value: "contact",
    },
    {
      label: "Vendor",
      value: "vendor",
    },
    {
      label: "Beneficary",
      value: "beneficary",
    },
    {
      label: "User",
      value: "user",
    },
  ];

  useEffect(() => {
    if (!trustIdsSetOnce && trustListing && trustListing.length > 0) {
      const allTrustIds = trustListing
        ?.filter((trustItem) => trustItem.value !== "new")
        ?.map((item) => item.value);
      setTrustId(allTrustIds);
      setTrustIdsSetOnce(true);
    }
  }, [trustListing, trustIdsSetOnce, setTrustId]);

  // Sync values to exported variables
  _trustId = trustId;
  _vendorId = vendorId;
  _contactId = contactId;
  _assetId = assetId;
  _sub_assetId = subAssetId;
  _contractId = contractId;
  _beneficaryId = beneficaryId;
  _userId = userId;

  useEffect(() => {
    if (setTrustListData) {
      setTrustListData(trustListing);
    }
  }, [setTrustListData, trustListing]);

  useEffect(() => {
    if (trustList) {
      let trustTempListing = trustList?.map((item) => ({
        ...item,
        value: item?.id,
        label: item?.business_name
          ? item?.business_name
          : item?.first_name
            ? item?.first_name + " " + item?.last_name
            : item?.last_name,
      }));

      setTrustListing(trustTempListing || []);
    } else {
      setTrustListing([]);
    }
  }, [trustList]);

  useEffect(() => {
    if (beneficaryList?.length > 0) {
      let beneficaryTempListing = beneficaryList?.map((item) => ({
        ...item,
        value: item?.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setBeneficaryListing(beneficaryTempListing || []);
    } else {
      setBeneficaryListing([]);
    }
  }, [beneficaryList]);

  useEffect(() => {
    if (vendorList) {
      let vendorTempListing = vendorList?.map((item) => ({
        ...item,
        value: item?.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setVendorListing(vendorTempListing || []);
    } else {
      setVendorListing([]);
    }
  }, [vendorList]);

  useEffect(() => {
    if (assetList) {
      let assetTempListing = assetList?.map((item) => ({
        ...item,
        value: item?.id,
        label: item?.name
          ? `${item.name}${item?.code ? ` (${item?.code})` : ""}`
          : "",
      }));
      setAssetListing(assetTempListing || []);
    } else {
      setAssetListing([]);
    }
  }, [assetList]);

  useEffect(() => {
    if (contactList) {
      let contactTempListing = contactList?.map((item) => ({
        ...item,
        value: item?.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setContactListing(contactTempListing || []);
    } else {
      setContactListing([]);
    }
  }, [contactList]);

  useEffect(() => {
    if (subAssetList) {
      let subAssetTempListing = subAssetList?.map((item) => ({
        ...item,
        value: item?.id,
        label: `${item.name}${
          item?.identifier ? ` (${item?.identifier})` : ""
        }`,
      }));
      setSubAssetListing(subAssetTempListing || []);
    } else {
      setSubAssetListing([]);
    }
  }, [subAssetList]);

  useEffect(() => {
    if (contractList) {
      let contractTempListing = contractList?.map((item) => ({
        ...item,
        value: item?.id,
        label: item?.contract_number ? item.contract_number : "",
      }));
      setContractListing(contractTempListing || []);
    } else {
      setContractListing([]);
    }
  }, [contractList]);

  useEffect(() => {
    if (userList) {
      let userTempListing = userList?.map((item) => ({
        ...item,
        value: item?.id,
        label: formatSubcontractorName(item),
      }));
      setUserListing(userTempListing || []);
    } else {
      setUserListing([]);
    }
  }, [userList]);

  const totalSelectedCount =
    trust &&
    getCount(trustId) +
      getCount(vendorId) +
      getCount(contactId) +
      getCount(assetId) +
      getCount(subAssetId) +
      getCount(contractId) +
      getCount(reversedId) +
      getCount(refundId) +
      getCount(disposedId) +
      getCount(amlCtfContactId) +
      getCount(beneficaryId) +
      getCount(userId) +
      (reportFilterValue ? 1 : 0);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="relative px-2">
          <FilterIcon className="h-4 w-4" />
          {totalSelectedCount > 0 && (
            <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-primary text-xs font-semibold text-secondary">
              {totalSelectedCount}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[250px]">
        {trust && organizationData?.organizationId && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="contact_id">
                    <CustomLabelText
                      labelText="Trust"
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    {multiTrust ? (
                      <TrustSelectMulti
                        orgId={organizationData?.organizationId}
                        options={trustListing?.filter(
                          (item) => item?.value !== "new",
                        )}
                        placeholder={"Select Trusts"}
                        onValueChange={(e) => {
                          setTrustId(e);
                          if (contact) {
                            setContactListing([]);
                            setContactList([]);
                            setContactId();
                          }
                          if (vendor) {
                            setVendorListing([]);
                            setVendorList([]);
                            setVendorId();
                          }
                          if (asset) {
                            setAssetListing([]);
                            setAssetList([]);
                            setAssetId();
                          }
                          if (subAsset) {
                            setSubAssetListing([]);
                            setSubAssetList([]);
                            setSubAssetId();
                          }
                          if (contract) {
                            setContractListing([]);
                            setContractList([]);
                            setContractId();
                          }
                        }}
                        variant="inverted"
                        animation={2}
                        maxCount={0}
                        defaultValue={trustId ? trustId : ""}
                        setTrustList={setTrustList} // Update vendor list as new data loads
                        setTrustLoading={setTrustLoading}
                        loading={trustLoading}
                      />
                    ) : (
                      <TrustSelect
                        orgId={organizationData?.organizationId}
                        frameworkData={trustListing} // List of vendors
                        optionType="Trust"
                        handleSelect={(e) => {
                          setTrustId(e);
                          if (contact) {
                            setContactListing([]);
                            setContactList([]);
                            setContactId();
                          }
                          if (vendor) {
                            setVendorListing([]);
                            setVendorList([]);
                            setVendorId();
                          }
                          if (asset) {
                            setAssetListing([]);
                            setAssetList([]);
                            setAssetId();
                          }
                          if (subAsset) {
                            setSubAssetListing([]);
                            setSubAssetList([]);
                            setSubAssetId();
                          }
                          if (contract) {
                            setContractListing([]);
                            setContractList([]);
                            setContractId();
                          }
                        }}
                        name="trust_id"
                        disabled={
                          organizationData?.organizationId ? false : true
                        }
                        initialValue={trustId ? trustId : ""}
                        setTrustList={setTrustList} // Update vendor list as new data loads
                        setTrustLoading={setTrustLoading} // Control loading state
                        onClear={() => {
                          setTrustId();
                          if (contact) {
                            setContactListing([]);
                            setContactList([]);
                            setContactId();
                          }
                          if (vendor) {
                            setVendorListing([]);
                            setVendorList([]);
                            setVendorId();
                          }
                          if (asset) {
                            setAssetListing([]);
                            setAssetList([]);
                            setAssetId();
                          }
                          if (subAsset) {
                            setSubAssetListing([]);
                            setSubAssetList([]);
                            setSubAssetId();
                          }
                          if (contract) {
                            setContractListing([]);
                            setContractList([]);
                            setContractId();
                          }
                        }}
                        loading={trustLoading}
                      />
                    )}
                    {trustLoading && (
                      <span className="absolute top-2 right-2 animate-spin">
                        <Loader2 width={20} height={20} />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        {contact && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="contact_id">
                    <CustomLabelText
                      labelText={getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "Customer",
                      )}
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    {multiContact ? (
                      <ContactSelectMulti
                        trustId={trustId}
                        options={contactListing}
                        placeholder={`Select ${getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "Customer",
                        )}`}
                        onValueChange={(e) => {
                          setContactId(e);
                        }}
                        loading={contactLoading}
                        variant="inverted"
                        animation={2}
                        maxCount={0}
                        disabled={trustId?.length === 0}
                        defaultValue={contactId ? contactId : ""}
                        setContactList={setContactList} // Update contact list as new data loads
                        setContactLoading={setContactLoading}
                      />
                    ) : (
                      <ContactSelect
                        trustId={trustId}
                        frameworkData={contactListing} // List of vendors
                        optionType={getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "Customer",
                        )}
                        handleSelect={(e) => {
                          setContactId(e);
                        }}
                        name="contact_id"
                        disabled={trustId ? false : true}
                        initialValue={contactId ? contactId : ""}
                        setContactList={setContactList} // Update vendor list as new data loads
                        setContactLoading={setContactLoading} // Control loading state
                        onClear={() => {
                          setContactId();
                        }}
                        loading={contactLoading}
                      />
                    )}
                    {contactLoading && (
                      <span className="absolute top-2 right-2 animate-spin">
                        <Loader2 width={20} height={20} />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        {vendor && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="vendor_id">
                    <CustomLabelText
                      labelText={getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor",
                      )}
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    {multiVendor ? (
                      <VendorSelectMulti
                        trustId={trustId}
                        options={vendorListing}
                        placeholder={`Select ${getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "vendors",
                          "Vendor",
                        )}`}
                        onValueChange={(e) => {
                          setVendorId(e);
                          if (asset) {
                            setAssetListing([]);
                            setAssetList([]);
                            setAssetId();
                          }
                          if (subAsset) {
                            setSubAssetListing([]);
                            setSubAssetList([]);
                            setSubAssetId();
                          }
                          if (beneficary) {
                            setBeneficaryListing([]);
                            setBeneficaryList([]);
                            setBeneficaryId();
                          }
                        }}
                        loading={vendorLoading}
                        variant="inverted"
                        animation={2}
                        maxCount={0}
                        disabled={trustId?.length === 0}
                        defaultValue={vendorId ? vendorId : ""}
                        setVendorList={setVendorList} // Update vendor list as new data loads
                        setVendorLoading={setVendorLoading}
                      />
                    ) : (
                      <VendorSelect
                        trustId={trustId}
                        frameworkData={vendorListing} // List of vendors
                        optionType={getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "vendors",
                          "Vendor",
                        )}
                        handleSelect={(e) => {
                          setVendorId(e);
                          if (asset) {
                            setAssetListing([]);
                            setAssetList([]);
                            setAssetId();
                          }
                          if (subAsset) {
                            setSubAssetListing([]);
                            setSubAssetList([]);
                            setSubAssetId();
                          }
                          if (beneficary) {
                            setBeneficaryListing([]);
                            setBeneficaryList([]);
                            setBeneficaryId();
                          }
                        }}
                        name="vendor_id"
                        disabled={false}
                        initialValue={vendorId ? vendorId : ""}
                        setVendorList={setVendorList} // Update vendor list as new data loads
                        setVendorLoading={setVendorLoading} // Control loading state
                        onClear={() => {
                          setVendorId();
                          if (asset) {
                            setAssetListing([]);
                            setAssetList([]);
                            setAssetId();
                          }
                          if (subAsset) {
                            setSubAssetListing([]);
                            setSubAssetList([]);
                            setSubAssetId();
                          }
                          if (beneficary) {
                            setBeneficaryListing([]);
                            setBeneficaryList([]);
                            setBeneficaryId();
                          }
                        }}
                        loading={vendorLoading}
                      />
                    )}
                    {vendorLoading && (
                      <span className="absolute top-2 right-2 animate-spin">
                        <Loader2 width={20} height={20} />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        {asset && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="asset_id">
                    <CustomLabelText
                      labelText={getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "assets",
                        "Asset",
                      )}
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    <AssetSelect
                      trustId={trustId}
                      vendorId={vendorId ? vendorId : ""}
                      frameworkData={assetListing} // List of vendors
                      optionType={getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "assets",
                        "Asset",
                      )}
                      handleSelect={(e) => {
                        setAssetId(e);
                        if (subAsset) {
                          setSubAssetListing([]);
                          setSubAssetList([]);
                          setSubAssetId();
                        }
                        if (contract) {
                          setContractListing([]);
                          setContractList([]);
                          setContractId();
                        }
                      }}
                      name="asset_id"
                      disabled={vendorId ? false : true}
                      initialValue={assetId ? assetId : ""}
                      setAssetList={setAssetList} // Update vendor list as new data loads
                      setAssetLoading={setAssetLoading} // Control loading state
                      onClear={() => {
                        setAssetId();
                        if (subAsset) {
                          setSubAssetListing([]);
                          setSubAssetList([]);
                          setSubAssetId();
                        }
                        if (contract) {
                          setContractListing([]);
                          setContractList([]);
                          setContractId();
                        }
                      }}
                      loading={assetLoading}
                    />
                    {assetLoading && (
                      <span className="absolute top-2 right-2 animate-spin">
                        <Loader2 width={20} height={20} />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        {subAsset && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="sub_asset_id">
                    <CustomLabelText
                      labelText={getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "sub-assets",
                        "Sub Asset",
                      )}
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    {multiSubAsset ? (
                      <SubAssetSelectMulti
                        trustId={trustId}
                        vendorId={vendorId}
                        options={subAssetListing}
                        placeholder={`Select ${getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "sub-assets",
                          "Sub Asset",
                        )}`}
                        onValueChange={(e) => {
                          setSubAssetId(e);
                          if (contract) {
                            setContractListing([]);
                            setContractList([]);
                            setContractId();
                          }
                        }}
                        loading={subAssetLoading}
                        variant="inverted"
                        animation={2}
                        maxCount={0}
                        disabled={trustId?.length === 0}
                        defaultValue={subAssetId ? subAssetId : ""}
                        setSubAssetList={setSubAssetList} // Update subAsset list as new data loads
                        setSubAssetLoading={setSubAssetLoading}
                      />
                    ) : (
                      <SubAssetSelect
                        trustId={trustId}
                        assetId={assetId ? assetId : ""}
                        frameworkData={subAssetListing} // List of subAssets
                        optionType={getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "sub-assets",
                          "Sub Asset",
                        )}
                        handleSelect={(e) => {
                          setSubAssetId(e);
                          if (contract) {
                            setContractListing([]);
                            setContractList([]);
                            setContractId();
                          }
                        }}
                        name="sub_asset_id"
                        disabled={assetId ? false : true}
                        initialValue={subAssetId ? subAssetId : ""}
                        setSubAssetList={setSubAssetList} // Update vendor list as new data loads
                        setSubAssetLoading={setSubAssetLoading} // Control loading state
                        onClear={() => {
                          setSubAssetId();
                          if (contract) {
                            setContractListing([]);
                            setContractList([]);
                            setContractId();
                          }
                        }}
                        loading={subAssetLoading}
                      />
                    )}
                    {subAssetLoading && (
                      <span className="absolute top-2 right-2 animate-spin">
                        <Loader2 width={20} height={20} />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        {beneficary && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="vendor_id">
                    <CustomLabelText
                      labelText={"Beneficary"}
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    {multiBeneficary ? (
                      <BeneficarySelectMulti
                        trustId={trustId}
                        vendorId={vendorId}
                        options={beneficaryListing}
                        placeholder={`Beneficary`}
                        onValueChange={(e) => {
                          setBeneficaryId(e);
                        }}
                        loading={beneficaryLoading}
                        variant="inverted"
                        animation={2}
                        maxCount={0}
                        disabled={vendorId?.length === 0}
                        defaultValue={beneficaryId ? beneficaryId : ""}
                        setBeneficaryList={setBeneficaryList} // Update vendor list as new data loads
                        setBeneficaryLoading={setBeneficaryLoading}
                      />
                    ) : (
                      <BeneficarySelect
                        trustId={trustId}
                        vendorId={vendorId}
                        frameworkData={beneficaryListing} // List of vendors
                        optionType={"Beneficary"}
                        handleSelect={(e) => {
                          setBeneficaryId(e);
                        }}
                        name="beneficary_id"
                        disabled={vendorId ? false : true}
                        initialValue={beneficaryId ? beneficaryId : ""}
                        setBeneficaryList={setBeneficaryList} // Update vendor list as new data loads
                        setBeneficaryLoading={setBeneficaryLoading} // Control loading state
                        onClear={() => {
                          setBeneficaryId();
                        }}
                        loading={beneficaryLoading}
                      />
                    )}
                    {beneficaryLoading && (
                      <span className="absolute top-2 right-2 animate-spin">
                        <Loader2 width={20} height={20} />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        {contract && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="contract_id">
                    <CustomLabelText
                      labelText="Contract"
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    <ContractSelect
                      trustId={trustId}
                      subAssetId={subAssetId ? subAssetId : ""}
                      frameworkData={contractListing} // List of vendors
                      optionType="Contract"
                      handleSelect={(e) => {
                        setContractId(e);
                      }}
                      name="contract_id"
                      disabled={subAssetId ? false : true}
                      initialValue={contractId ? contractId : ""}
                      setContractList={setContractList} // Update vendor list as new data loads
                      setContractLoading={setContractLoading} // Control loading state
                      onClear={() => {
                        setContractId();
                      }}
                      loading={contractLoading}
                    />
                    {contractLoading && (
                      <span className="absolute top-2 right-2 animate-spin">
                        <Loader2 width={20} height={20} />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        {beneficary && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="user_id">
                    <CustomLabelText
                      labelText={"User"}
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    {multiUser ? (
                      <UserSelectMulti
                        orgId={organizationData?.organizationId}
                        options={userListing?.filter(
                          (item) => item?.value !== "new",
                        )}
                        placeholder={"Select Users"}
                        onValueChange={(e) => {
                          setUserId(e);
                        }}
                        className={"bg-background"}
                        variant="inverted"
                        animation={2}
                        maxCount={0}
                        defaultValue={userId ? userId : ""}
                        setUserList={setUserList} // Update vendor list as new data loads
                        setUserLoading={setUserLoading}
                        loading={userLoading}
                      />
                    ) : (
                      <UserSelect
                        orgId={organizationData?.organizationId}
                        frameworkData={userListing} // List of vendors
                        optionType="User"
                        handleSelect={(e) => {
                          setUserId(e);
                        }}
                        hideUserId={false}
                        name="user_id"
                        initialValue={userId ? userId : ""}
                        authUser={true}
                        setUserList={setUserList}
                        setUserLoading={setUserLoading}
                        onClear={() => {
                          setUserId();
                        }}
                        loading={userLoading}
                      />
                    )}
                    {beneficaryLoading && (
                      <span className="absolute top-2 right-2 animate-spin">
                        <Loader2 width={20} height={20} />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        {aml_ctf_contact && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="aml_ctf_contact_id">
                    <CustomLabelText
                      labelText="AML/CTF Contact"
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    <SearchSelect
                      frameworks={commonList}
                      optionType={"AML/CTF Contact"}
                      handleSelect={(e) => {
                        setAmlCtfContactId(e);
                      }}
                      disabled={trustLoading}
                      clearable={true}
                      initialValue={amlCtfContactId ? amlCtfContactId : ""}
                      onClear={() => {
                        setAmlCtfContactId();
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        {reversed && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="reversed_id">
                    <CustomLabelText
                      labelText="Reversed"
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    <SearchSelect
                      frameworks={commonList}
                      optionType={"Reversed"}
                      handleSelect={(e) => {
                        setReversedId(e);
                      }}
                      disabled={false}
                      clearable={true}
                      initialValue={reversedId ? reversedId : ""}
                      onClear={() => {
                        setReversedId();
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        {amlDashboardFilter && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="refund_id">
                    <CustomLabelText
                      labelText="Contact Type"
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    <SearchSelect
                      frameworks={amlDashboardList}
                      optionType={"Contact Type"}
                      handleSelect={(e) => {
                        setAmlDashboardValue(e);
                      }}
                      disabled={false}
                      initialValue={amlDashboardValue ? amlDashboardValue : ""}
                      clearable={true}
                      onClear={() => {
                        setAmlDashboardValue();
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        {refund && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="refund_id">
                    <CustomLabelText
                      labelText="Refund"
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    <SearchSelect
                      frameworks={commonList}
                      optionType={"Refund"}
                      handleSelect={(e) => {
                        setRefundId(e);
                      }}
                      disabled={false}
                      initialValue={refundId ? refundId : ""}
                      clearable={true}
                      onClear={() => {
                        setRefundId();
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        {disposed && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="disposed_id">
                    <CustomLabelText
                      labelText="Disposed"
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    <SearchSelect
                      frameworks={commonList}
                      optionType={"Disposed"}
                      handleSelect={(e) => {
                        setDisposedId(e);
                      }}
                      disabled={false}
                      initialValue={disposedId ? disposedId : ""}
                      clearable={true}
                      onClear={() => {
                        setDisposedId();
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        {reportFilter && (
          <DropdownMenuItem
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
            // onPointerDown={(e) => e.stopPropagation()}
            // onClick={(e) => e.preventDefault()}
            >
              <div className="grid gap-2">
                <div className="min-w-0">
                  <Label htmlFor="reversed_id">
                    <CustomLabelText
                      labelText="Visible"
                      errorField={""}
                      className={"mb-2"}
                    />
                  </Label>
                  <div className="relative">
                    <SearchSelect
                      frameworks={reportFilterList}
                      optionType={"Visible"}
                      handleSelect={(e) => {
                        setReportFilterValue(e);
                      }}
                      disabled={false}
                      clearable={true}
                      initialValue={reportFilterValue ? reportFilterValue : ""}
                      onClear={() => {
                        setReportFilterValue();
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        )}

        <>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={(e) => {
              e.preventDefault();
              vendor && setVendorId("");
              contact && setContactId("");
              aml_ctf_contact && setAmlCtfContactId();
              reversed && setReversedId();
              refund && setRefundId();
              disposed && setDisposedId();
              if (trust) {
                setTrustId("");
                vendor && setVendorListing([]);
                vendor && setVendorList([]);
                vendor && setVendorId("");
                contact && setContactListing([]);
                contact && setContactList([]);
                contact && setContactId("");
              }
              if (asset) {
                setAssetListing([]);
                setAssetList([]);
                setAssetId();
              }
              if (subAsset) {
                setSubAssetListing([]);
                setSubAssetList([]);
                setSubAssetId();
              }
              if (contract) {
                setContractListing([]);
                setContractList([]);
                setContractId();
              }
              if (reportFilter) {
                reportFilterValue && setReportFilterValue("1");
              }
            }}
            className="text-red-500 focus:bg-destructive/10"
          >
            Reset
          </DropdownMenuItem>
        </>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
